module.exports = __webpack_public_path__ + "media/images/emblems/Tubach-cfb594904496fb04e464466ab4caa09a.png";